import React from 'react'
import XIcon from 'wix-ui-icons-common/X'
import {useTranslation} from '@wix/yoshi-flow-editor'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import c from '../../../classnames.scss'
import s from '../coupon-input.scss'
import {CouponInputClearButtonProps} from '.'

export const CouponInputClearButton = ({onClick}: CouponInputClearButtonProps) => {
  const {t} = useTranslation()

  return (
    <button
      type="button"
      aria-label={t('a11y.clearCouponCodeButton')}
      data-hook={DH.COUPON_CODE_CLEAR}
      className={classNames(s.couponCancel, c.formSummaryCouponCancel)}
      onClick={onClick}
    >
      <XIcon className={s.couponCancelIcon} size="17px" />
    </button>
  )
}
